import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Cultivo} from "../../../../../chacra-core/models/cultivos";

export const cultivosAdapter: EntityAdapter<Cultivo> = createEntityAdapter<Cultivo>({
  selectId: model => model.cultivoId,
  sortComparer: (a: Cultivo, b: Cultivo): number =>
    b.cultivoId.toString().localeCompare(a.cultivoId.toString())
});

export interface CultivosState extends EntityState<Cultivo> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: CultivosState = cultivosAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
